<template>
  <div>
    <banner/>
    <steps/>
    <recentHistory/>
    <partnercarousel/>
    <getapp/>
    <testimonialcarousel/>
  </div>
</template>

<script>
  import banner from '@/components/Home/Banner';
  import steps from '@/components/Home/Steps';
  import recentHistory from '@/components/Home/RecentHistory';
  import partnercarousel from '@/components/Home/PartnerCarousel';
  import getapp from '@/components/Home/GetApp';
  import testimonialcarousel from '@/components/Home/TestimonialCarousel';
  import axios from "axios";

  export default {
    name: 'Home',
    components: {
      banner,
      steps,
      recentHistory,
      partnercarousel,
      getapp,
      testimonialcarousel
    },
    created() {
      const self = this;
      let source = self.$route.query.utm_source;
      if(source != undefined) {
        axios.defaults.headers.common['distribution'] = source;
      } else {
        axios.defaults.headers.common['distribution'] = 'd2c';
      }
    },
  }
</script>



// WEBPACK FOOTER //
// src/views/Home.vue